var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('vs-button',{attrs:{"color":"danger","icon-pack":"feather","icon":"icon-trash","title":_vm.$t('buttons.remove')},on:{"click":_vm.doRemove}},[_vm._v(" "+_vm._s(_vm.$t("buttons.remove"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }